import type { FC } from "react";

import { useTrustPilotConfig } from "@ui/hooks/useTrustPilotConfig";
import classNames from "classnames";

type TrustPilotMicroComboProps = {
  theme?: "light" | "dark";
  className?: string;
  width?: string;
  height?: string;
};

export const TrustPilotMicroCombo: FC<TrustPilotMicroComboProps> = ({
  theme,
  className,
  width = "100%",
  height = "20px",
}) => {
  const {
    ref,
    isEnabled,
    localeCode,
    businessUnitId,
    templateId,
    leaveAReviewLink,
    theme: globalTheme,
  } = useTrustPilotConfig("microComboWidgetTemplateId", { width, height, theme });

  if (!isEnabled) {
    return null;
  }

  return (
    <div
      ref={ref}
      data-testid="trustpilot-micro-combo"
      className={classNames("trustpilot-widget", className)}
      data-locale={localeCode}
      data-template-id={templateId}
      data-businessunit-id={businessUnitId}
      data-style-height={height}
      data-style-width={width}
      data-theme={theme || globalTheme}
    >
      <a href={leaveAReviewLink} target="_blank" rel="noopener noreferrer">
        Trustpilot
      </a>
    </div>
  );
};
